module.exports = __webpack_public_path__ + "media/images/hackerrank_logo-8512a0c2a88a88644a7015c0333a3184.png";